import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const testApi = createApi({
  reducerPath: "testApi",
  baseQuery: fetchBaseQuery({
    // baseUrl: `http://localhost:8002/`,
    baseUrl: `${process.env.REACT_APP_CONTENT_SERVER_BACKEND_URL}`,
    validateStatus: (response) => {
      if (response.status === 401) {
        window.location.href = "/login";
        return false;
      } else if (response.status >= 200 && response.status < 300) {
        return true;
      } else {
        throw new Error(`HTTP error ${response.status}`);
      }
    },
  }),
  endpoints: (builder) => ({
    getAllTest: builder.mutation({
      query: (body) => ({
        url: `api/contentServices/test/getTestsAdminPanel`,
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    createTest: builder.mutation({
      query: (body) => ({
        url: "api/contentServices/test/createTest",
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    updateTest: builder.mutation({
      query: (body) => ({
        url: "api/contentServices/test/updateTest",
        method: "PUT",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    deleteTest: builder.mutation({
      query: (body) => ({
        url: "api/contentServices/test/deleteTest",
        method: "DELETE",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
  }),
});

export const {
  useGetAllTestMutation,
  useCreateTestMutation,
  useUpdateTestMutation,
  useDeleteTestMutation,
} = testApi;
